const wrapper = "_275wb5kyjr";
const content = "_275c1x393qf";
const footer = "_275fuc79ht";

export { content, footer, wrapper };
import "./_render-page.style.linaria.module.css";
//# sourceMappingURL=_render-page.style.js.map
